export default __webpack_public_path__ + "static/media/creatingDrafts.2af5635e.png";